<template>
<div class="disclaimers__container">
	<button v-if="$route.name === 'Home' || $route.name === 'Overview'" class="disclaimers-btn" @click="toggleDisclosures()">
		Product Disclosures
		<span class="material-icons-outlined" :class="{'flipped': showDisclaimers}">
			expand_more
		</span>
	</button>
	<div v-else class="disclaimers-head">Product Disclosures</div>
<div class="disclaimers" :class="{'show-disclaimers': showDisclaimers}">
	<template  v-for="(disclaimer, key) in disclaimers">
	<div class="discliamer" :key="key" v-if="key === $route.name || ($route.name === 'Home' || $route.name === 'Overview') && productIsSelected(key)">
		<p v-for="(paragraph, p) in disclaimer" :key="paragraph">
			<b v-if="p === 0">{{paragraph}}</b>
			<span v-else>{{paragraph}}</span>
			</p>
	</div>
	</template>
	</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
data() {
	return {
		showDisclaimers: false,
		disclaimers: {
			AccidentExpense: [
				'Group Accident Expense',
				'Group Accident Expense insurance provides limited benefit coverage and may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee\'s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefits descriptions and conditions, see the policy/certificate.',
				'Circular 230 Disclosure: Any U.S. tax information contained in this communication is not intended or written to be used, and cannot be used, for the purpose of (i) avoiding penalties under the Internal Revenue Code, or (ii) promoting, marketing or recommending to another party any matters addressed herein.',
				'Policy/Certificate Form Nos. G H1708 and G H1708C and Rider Form Nos. R G1712C Accidental Death and Dismemberment Rider; R G1710C Outpatient Care Rider; R G1711C Hospital Sickness Rider and R G1709C Accident-Only Disability Income Rider underwritten by Assurity Life Insurance Company, Lincoln, NE. This policy may contain reduction of benefits, limitations and exclusions. For costs and complete details of the coverage, please contact your agent, Assurity or ask to review the policy/certificate for more information.'
			],
			HospitalIndemnity: [
				'Group Hospital Indemnity',
				'Group Hospital Indemnity insurance provides limited benefit coverage, is not a substitute for major medical insurance, and may not be appropriate for Medicaid recipients. It is not comprehensive major medical insurance and does not satisfy the requirement for minimum essential coverage under the Affordable Care Act (ACA). It may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee’s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefits descriptions and conditions, see the policy/certificate.',
				'Circular 230 Disclosure: Any U.S. tax information contained in this communication is not intended or written to be used, and cannot be used, for the purpose of (i) avoiding penalties under the Internal Revenue Code, or (ii) promoting, marketing or recommending to another party any matters addressed herein.',
				'Policy/Certificate Form Nos. G H1730/G H1730C, G H1731/G H1731C and Hospital Indemnity Care Certificate Rider R G1736C underwritten by Assurity Life Insurance Company, Lincoln, NE.'
			],
			CriticalIllness: [
				'Group Critical Illness',
				'Group Critical Illness insurance provides limited benefit coverage, is not a substitute for major medical insurance, may not be appropriate for Medicaid recipients, and may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee’s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefits descriptions and conditions, see the policy/certificate.',
				'Circular 230 Disclosure: Any U.S. tax information contained in this communication is not intended or written to be used, and cannot be used, for the purpose of (i) avoiding penalties under the Internal Revenue Code, or (ii) promoting, marketing or recommending to another party any matters addressed herein.',
				'Policy Form No. G H1715/G H1715C , and Rider Form No. R G1716C Additional Critical Illness Rider; R G1717C Cardiopulmonary Rider; R G1718C Childhood Critical Illness Rider; R G1719C Genetic Screening Test Rider; R G1720C Health Screening Rider; R G1721C Increasing Benefit Rider; R G1722C Specified Disease Rider underwritten by Assurity Life Insurance Company of Lincoln, NE. This policy may contain reduction of benefits, limitations and exclusions. For costs and complete details of the coverage, please contact your insurance professional, Assurity or ask to review the policy for more information.',
			],
			DisabilityIncome: [
				'Group Short-Term Disability',
				'Group Short-Term Disability Income insurance may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee’s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefits descriptions and conditions, see the policy/certificate.',
				'Policy/Certificate Form Nos. G H1808/G H1808C and Certificate Rider Form Nos. R G1809C, R G1814C, R G1810C, R G1811C, R G1812C and R G1813C underwritten by Assurity Life Insurance Company, Lincoln, NE.',
			],
			TermLife: [
				'Group Term Life',
				"Group Term Life insurance and its rider's availability, benefits and premiums as presented may be subject to approval of Assurity. Some applicants may not be eligible for coverage. Group Term Life Insurance and its riders may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee’s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefit description and conditions, see the policy/certificate. Policy availability, features and rates may vary by state.",
				'Policy/Certificate Form Nos. G L2307/G L2307C and Rider Nos. Form R G2308C, Form R G2310C, Form: R G2311C and Form R GL2309C underwritten by Assurity Life Insurance Company, Lincoln, NE.',
			],
			WholeLife: [
				'Group Whole Life',
				'Group Whole Life insurance may contain reductions of benefits, limitations and exclusions. The description of benefits is intended only to highlight the insured employee’s benefits and should not be relied upon to fully determine coverage. If this description conflicts in any way with the terms of the policy/certificate, the terms of the policy/certificate prevail. For complete benefits descriptions and conditions, see the policy/certificate.',
				'Policy/Certificate Form Nos. G L1913/G L1913C and Rider Nos. R G1914C, R G1915C, R G1916C, R G1917C and R G1918C underwritten by Assurity Life Insurance Company, Lincoln, NE.'
			]
		}	
	}
},
watch: {
	'$route.name': function(val) {
		this.showDisclaimers = (val !== 'Home' && val !== 'Overview');
	}
	
},
computed: {
	...mapGetters({
		products: 'getProducts'
	})
},
methods: {
	productIsSelected(id) {
		return this.products.map(product => product.Id).includes(id)
	},
	toggleDisclosures(){
		if(this.$route.name === 'Home' || this.$route.name === 'Overview') {
			this.showDisclaimers = !this.showDisclaimers;
		}
	}
},
}
</script>

<style lang="scss" scoped>
.disclaimers__container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}
.disclaimers {
	transition: .3s ease all;
	max-height: 0;
	overflow: hidden;
}
	.disclaimers-btn {
		border: none;
		background: none;
		color: $red;
		display: flex;
		justify-self: center;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
		cursor: pointer;
	}
	.disclaimers-head {
		border: none;
		background: none;
		color: $red;
		display: flex;
		justify-self: center;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
	}
.show-disclaimers {
	max-height: none;
	overflow: visible;
}
.material-icons-outlined {
	color: $red;
	transition: .3s ease all;
}
.flipped {
	transform: rotateX(180deg)
}
</style>
